import i18next from "i18next";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { StorageService } from "./../../services/storage.service";
import actions from "./../../store/actions/actions";
import { Utils } from "./../../utils/utils";
import Breadcrumbs from "./../Common/Breadcrumbs";
import { FloorForm } from "./FloorForm";

export const EditFloor = (props) => {
  const floorId = props.match.params.id;
  const storageService = new StorageService();
  const history= useHistory()
  const [defaultSelectedLanguage, setDefaultLanguage] = useState(null);
  const hotelId = +storageService.getItem("hotelId");
  const hotelName = useSelector((state) => state?.hotelDetails?.result?.name);
  const dispatch = useDispatch();
  const availableLanguagesFromSelector = useSelector(
    (state) => state.constants.languages
  );
  const availableFilteredLanguages = Utils.setupLanguageRes(
    availableLanguagesFromSelector
  );

  const floorDetails = useSelector((state) => state?.floor?.result);
  const [currentFloorName, setCurrentFloorName] = useState(null);
  const breadcrumbs = [
    { path: "/hotel-management", title: "Hotels" },
    { path: "/hotel-configuration", title: hotelName ? hotelName : "" },
    { path: "/hotel-floor/list", title: "Floor List" },
    { path: `/hotel-floor/edit/${floorId}`, title: `${currentFloorName}` },
  ];
  const { t } = useTranslation();

  useEffect(() => {
    getFloorDetails();
  }, [floorId]);

  useEffect(() => {
    if (defaultSelectedLanguage && floorDetails) {
      const changedFloorName = findExistingLanguage(
        floorDetails?.h_floor_ts,
        defaultSelectedLanguage
      );
      if (changedFloorName && changedFloorName?.language_id) {
        setCurrentFloorName(changedFloorName?.name);
      } else {
        setCurrentFloorName(floorDetails?.h_floor_ts[0].name);
      }
    }
  }, [defaultSelectedLanguage, floorDetails]);

  useEffect(() => {
    if (i18next.language && availableLanguagesFromSelector) {
      const langInfo = selectedLangId(i18next.language?.toLowerCase());

      if (langInfo) {
        setDefaultLanguage(langInfo?.language?.id);
      } else {
        setDefaultLanguage(availableFilteredLanguages[0]?.language?.id);
      }
    }
  }, [i18next.language, availableLanguagesFromSelector]);

  const findExistingLanguage = (languageBLock, selectedLangId) => {
    return (languageBLock || []).find((translationContent) => {
      return +translationContent.language_id === +selectedLangId;
    });
  };

  const isUpdated = useSelector((state)=>state?.floor?.isUpdate)

  useEffect(()=>{
    if(isUpdated){
      history.push("/hotel-floor/list")
    }
  },[isUpdated])

  const getFloorDetails = () => {
    dispatch(actions.getFloorDetail(floorId));
  };

  const selectedLangId = (selectedLang) => {
    return availableLanguagesFromSelector?.find((langInfo) => {
      return (
        langInfo?.language?.code?.toLowerCase() ===
          selectedLang.toLowerCase() ||
        langInfo?.language?.key?.toLowerCase() === selectedLang.toLowerCase()
      );
    });
  };

  return (
    <React.Fragment>
      <div className="breadcrumbs">
        <Row>
          <Col>
            <Breadcrumbs BreadcrumbData={breadcrumbs} />
          </Col>
        </Row>
        <Row>
          <Col md={6} sm={6} xs={6}>
            <h3> {t("Modules.Floor list (edit).Edit floor")} </h3>
          </Col>
        </Row>
      </div>
      <div className="content">
        <FloorForm
          isForEdit={true}
          floorDetails={floorDetails}
          hotelId={hotelId}
          floorId={floorId}
          updateFloor={getFloorDetails}
        />
      </div>
    </React.Fragment>
  );
};
